/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Republish_Candidate_ThisInputs */

const vi_einvoice_republish_candidate_this = /** @type {(inputs: Einvoice_Republish_Candidate_ThisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đây là hóa đơn của đơn này`)
};

/**

* @param {Einvoice_Republish_Candidate_ThisInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_republish_candidate_this = /** @type {((inputs?: Einvoice_Republish_Candidate_ThisInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Republish_Candidate_ThisInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_republish_candidate_this(inputs)
});